import React from 'react';
import * as R from 'ramda';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';

import { useTheme } from 'features/sharedModules/styles/components/styles.js';
import { Colors } from 'features/shared/constants/colors.js';

const options = {
  credits: {
    enabled: false
  },
  chart: {
    backgroundColor: null,
    plotBackgroundColor: null,
    plotBorderWidth: 0,
    plotShadow: false,
    width: '40',
    height: '40',
    spacingTop: 0,
    spacingBottom: 0,
    spacingLeft: 0,
    spacingRight: 0,
    animation: false
  },
  plotOptions: {
    series: {
      name: 'Portfolio',
      animation: false,
      enableMouseTracking: false
    },
    pie: {
      dataLabels: {
        enabled: false
      },
      states: {
        enabled: false,
        hover: {
          lineWidthPlus: 2
        }
      }
    }
  },
  tooltip: {
    enabled: false
  },
  series: [
    {
      type: 'pie',
      innerSize: '50%'
    }
  ],
  title: {
    text: null
  }
};

const MiniPieChart = ({ percent }) => {
  const theme = useTheme();
  const plotOptions = R.set(
    R.lensPath(['series', 0, 'data']),
    [
      {
        color: theme.primaryColor,
        y: percent
      },
      {
        color: Colors.backtestLightGreenGraphColor,
        y: 100 - percent
      }
    ],
    options
  );

  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType={'chart'}
      options={plotOptions}
    />
  );
};

export default MiniPieChart;
